import type { FunctionComponent, ReactNode } from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import ChangesIcon from '@atlaskit/icon/core/changes';

import Logo from './Logo';
import AtlassianUserIcon from './AtlassianUserIcon';

type Props = {
  icon?: ReactNode;
};

const AppLogos: FunctionComponent<Props> = ({ icon }) => (
  <Inline alignBlock="center" space={'space.100'}>
    <Logo />
    <ChangesIcon label="" />
    <AtlassianUserIcon icon={icon} />
  </Inline>
);

export default AppLogos;
